
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  ExamV2Custom,
  StructExamDimensionConfig,
  StructExamRandomConfig,
  StructExamQuestionConfig
} from "@/lib/model/exambuilder/exam-v2";
import {
  QuestionV2Object,
  QuestionV2
} from "@/lib/model/exambuilder/question-v2";
import _ from "lodash-es";
@Component({})
export default class SetInquiry extends Vue {
  @Prop({}) exam!: ExamV2Custom;

  inputWidth = "150px";
  visible = false;

  loading = false;
  isRandom = false; //抽题组追问设置
  examRandomConfigList: StructExamRandomConfig[] = []; //随机抽题题目追问list
  examQuestionConfigList: StructExamQuestionConfig[] = []; //固定题目追问list
  selectedQuestionList: QuestionV2[] = []; //题目list
  examDimensionConfigList: StructExamDimensionConfig[] = []; //面试维度系数配置list
  options = 3;
  // 抽题组题干
  getRandomText(questionGroup: StructExamRandomConfig, index: number) {
    return `组${index + 1}：${
      questionGroup.questionIdList.length > 0
        ? questionGroup.name || "抽题组卷题"
        : "抽题组卷题"
    } | ${questionGroup.questionIdList.length}抽${
      questionGroup.questionNumber
    } | ${
      questionGroup.questionIdList.length > 0
        ? questionGroup.getQuestionTypeText() || "未选择题型"
        : "未选择题型"
    }`;
  }
  // 是否支持追问功能
  isAppendAsk(questionId: number): boolean {
    const question = this.selectedQuestionList.find(
      q => q.questionId === questionId
    );
    return question?.isAppendAsk === 1;
  }
  // 固定组题干
  getSelectedText(questionId: number, index: number) {
    const question = this.selectedQuestionList.find(
      q => q.questionId === questionId
    );
    let str = "";
    if (question) {
      str = `${index + 1}、[${question.getQuestionTypeText()}] ${
        question.descTextOnly
      }`;
    }
    return str;
  }
  infoAssign(save = false) {
    if (save) {
      this.exam.examDimensionConfigList = this.examDimensionConfigList;
      if (this.isRandom) {
        this.exam.examRandomConfigList = this.examRandomConfigList;
      } else {
        this.exam.examQuestionConfigList = this.examQuestionConfigList;
      }
    } else {
      this.examDimensionConfigList = _.cloneDeep(
        this.exam.examDimensionConfigList
      );
      if (this.isRandom) {
        this.examRandomConfigList = _.cloneDeep(this.exam.examRandomConfigList);
      } else {
        this.examQuestionConfigList = _.cloneDeep(
          this.exam.examQuestionConfigList
        );
      }
    }
  }
  async getQuestionList() {
    if (this.exam.questionIdList && this.exam.questionIdList.length > 0) {
      const param = {
        questionIdList: this.exam.questionIdList,
        dimensionKeyFilterList: this.exam.dimensionKeyList
      };
      const qo2 = await QuestionV2Object.get(param);
      this.selectedQuestionList = qo2.list;
      if (this.selectedQuestionList.length < this.exam.questionIdList.length) {
        // 数据不一致，有题目被删除，需要重新生成题目list
        this.exam.questionIdList = this.selectedQuestionList.map(question => {
          return question.questionId;
        });
        this.getQuestionList();
        return;
      }

      this.selectedQuestionList.sort((q1, q2) => {
        return (
          this.exam.questionIdList.indexOf(Number(q1.questionId)) -
          this.exam.questionIdList.indexOf(Number(q2.questionId))
        );
      });
    }
  }

  onInput(e: Event) {
    if (e && e.target) {
      e.target["value"] = e.target["value"]
        .replace(/。/g, ".")
        .replace(/^\./g, "")
        .replace(/[^\d.]/g, "")
        .replace(/^0+\d*/g, "0") //不能为0开头的串，eg:"00,01,...等"
        .replace(/^\d{2,}\.?/g, "10") //最大值10
        .replace(/(\.\d+)\.+/g, "$1")
        .replace(/(\..*)\./g, "$1")
        .replace(/^()*(\d+)\.(\d\d).*$/, "$1$2.$3"); //小数点后最多保留两位
    }
  }

  openVisible() {
    this.visible = true;
    this.isRandom = this.exam.isRandomQuestions === 1;
    this.getQuestionList();
    this.infoAssign();
  }
  // 追问保存
  async inquirySubmit() {
    this.infoAssign(true);
    this.visible = false;
  }
}
